export const CHATBOT_NEW_PHASE = {
    IDLE: 'idle',
    LOADING: 'loading',
    ACTIVE: 'active',
    COMPLETED: 'completed',
    ERROR: 'error',
    BLOCKED: 'blocked',
};

export const initialChatbotNewState = {
    phase: 'idle',
    isSaving: false,
    error: '',
    testId: '',
    invitationId: '',
    invitationTypeName: '',
    flatQuestions: [],
    currentQuestionIndex: -1,
    answeredQuestions: [],
    editingQuestionIndex: -1,
    ccQuestion: {},
    bodyRegionList: [],
    groups: [],
    // Biometric modal and prompt state
    biometricModalOpen: false,
    showBiometricPrompt: false,
    biometricStatus: 'pending', // 'pending' | 'started' | 'completed' | 'skipped'
    isBlocked: false,
    exitWorkflowMessage: '',
    biometricGroupHeaderDescription: '',
    showBiometricCautionAlert: false,
    tenantFeatures: {},
};
